import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForSeparator = makeThemedStyles('BreadCrumb.Separator', () => ({
  Separator: {
    display: 'inline-flex',
    color: '#a2a5a9'
  },
  icon: {}
}));

interface SeparatorProps {
  className?: string;
  variant?: Array<any>;
  icon: 'NavigateNext' | 'NavigateBefore';
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const Separator: React.FunctionComponent<SeparatorProps> = (props: SeparatorProps) => {
  const styles = useStylesForSeparator();
  return (
    <div className={clsx(styles.Separator)} style={{ ...(props.style || {}), ...{} }}>
      {props.icon === 'NavigateNext' ? (
        <NavigateNextIcon classes={{ root: styles.icon }} />
      ) : props.icon === 'NavigateBefore' ? (
        <NavigateBeforeIcon classes={{ root: styles.icon }} />
      ) : null}
    </div>
  );
};
export default Separator;
